/* Shared option lists + initial form state for CoupleSignup. */

export const WEDDING_TYPE_OPTIONS = [
  "Civil Ceremony",
  "Hindu Wedding",
  "Reception",
  "Haldi",
  "Religious wedding",
  "Other",
];

export const SERVICES_OPTIONS = [
  "DJ",
  "Production",
  "Venue",
  "Event Planner",
  "Photographer",
  "Videographer",
  "Florist",
  "Caterer",
  "Hair & Makeup",
  "Decor / Styling",
  "Entertainment",
  "Bridalwear / Accessories",
  "Gift bags",
  "Wedding Cakes",
  "Wedding Stationery",
  "PhotoBooth",
  "Other",
];

export const COMMUNICATION_OPTIONS = [
  "Phone",
  "Email",
  "Email and Phone",
  "Face-to-face",
];

export const VIBE_OPTIONS = [
  "Elegant",
  "Modern",
  "Cultural",
  "Luxury",
  "Minimal",
  "Vibrant",
  "Other",
];

export const HEARD_OPTIONS = [
  "Website",
  "Tik Tok",
  "Instagram",
  "Word of mouth",
  "Facebook",
  "Youtube",
  "Other",
];

export const initialState = {
  couple_full_name: "",
  email: "",
  mobile_number: "",
  wedding_date: "",
  venue_address: "",
  venue_restrictions: "",
  social_handles: "",
  budget: "",
  wedding_type: [],
  services_needed: [],
  guest_count: "",
  priorities: "",
  must_haves: "",
  communication_preference: "",
  overall_vibe: "",
  vendors_already_booked: "",
  anything_else: "",
  heard_about_us: "",
  intro_slot_date: "",
  intro_slot_time: "",
  declaration_confirmed: false,
};

export const REQUIRED_TEXT_FIELDS = [
  ["couple_full_name", "Full name of couple"],
  ["email", "Email address"],
  ["mobile_number", "Mobile number"],
  ["wedding_date", "Date of the wedding"],
  ["venue_address", "Venue and address"],
  ["venue_restrictions", "Venue restrictions or requirements"],
  ["social_handles", "Social media handles"],
  ["budget", "Overall budget"],
  ["guest_count", "Guest count"],
  ["priorities", "Priorities"],
  ["must_haves", "Must-haves or deal-breakers"],
  ["communication_preference", "Preferred communication"],
  ["overall_vibe", "Overall vibe"],
  ["vendors_already_booked", "Vendors already booked"],
  ["anything_else", "Anything else"],
  ["heard_about_us", "How did you hear about us"],
];
